import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { QueryClientComponent } from "@ribondao/shared/hooks";
import { ToastContextProvider } from "contexts/toastContext";
import Toast from "contexts/toastContext/toastComponent";
import { Suspense } from "react";
import Zendesk from "config/zendesk";
import CurrentUserProvider from "contexts/currentUserContext";
import CausesProvider from "contexts/causesContext";
import NonProfitsProvider from "contexts/nonProfitsContext";
import DebugEventsView from "config/debugEventsView";
import { debugEnabled } from "config/debugEventsView/helpers";
import AuthenticationProvider from "contexts/authenticationContext";
import TagDonationProvider from "contexts/tagDonationContext";
import UserLevelProvider from "contexts/userLevelContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
import TicketsProvider from "contexts/ticketsContext";
import CouponProvider from "contexts/couponContext";
import IntegrationProvider from "contexts/integrationContext";
import LoadingOverlayProvider from "./contexts/loadingOverlayContext";
import ModalProvider from "./contexts/modalContext";
import RoutesComponent from "./config/routes";
import GlobalStyle from "./styles/globalStyle";
import theme from "./styles/theme";

function App() {
  // useEffect(() => {
  //   if (
  //     process.env.NODE_ENV === "development" ||
  //     process.env.NODE_ENV === "test"
  //   ) {
  //     if (DEBUG_EVENTS_ENABLED) growthbookSetFeatures();
  //     return;
  //   }

  //   growthbookSetFeatures();
  //   // eslint-disable-next-line no-console
  //   growthbookSetAttributes().catch(console.error);
  // }, []);

  return (
    <QueryClientComponent>
      {/* <GrowthBookProvider growthbook={growthbook}> */}
      <ThemeProvider theme={theme}>
        <LoadingOverlayProvider>
          <GlobalStyle />
          <BrowserRouter>
            {debugEnabled() && <DebugEventsView />}
            <ToastContextProvider>
              <IntegrationProvider>
                <CurrentUserProvider>
                  <GoogleOAuthProvider
                    clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID!}
                  >
                    <AuthenticationProvider>
                      <ModalProvider>
                        <Suspense fallback={<div />}>
                          <TicketsProvider>
                            <CouponProvider>
                              <NonProfitsProvider>
                                <CausesProvider>
                                  <TagDonationProvider>
                                    <UserLevelProvider>
                                      <RoutesComponent />
                                      <Zendesk />
                                    </UserLevelProvider>
                                  </TagDonationProvider>
                                </CausesProvider>
                              </NonProfitsProvider>
                            </CouponProvider>
                          </TicketsProvider>
                        </Suspense>
                      </ModalProvider>
                    </AuthenticationProvider>
                  </GoogleOAuthProvider>
                </CurrentUserProvider>
              </IntegrationProvider>
              <Toast />
            </ToastContextProvider>
          </BrowserRouter>
        </LoadingOverlayProvider>
      </ThemeProvider>
      {/* </GrowthBookProvider> */}
    </QueryClientComponent>
  );
}

export default App;
